"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formCoupler = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _assign2 = _interopRequireDefault(require("lodash/assign"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdFormik = require("cccisd-formik");
var _ImagePicker = _interopRequireDefault(require("../../ImagePicker"));
var _helpers = require("../../helpers");
var _navigations = require("../../../navigations");
var _SurveySelector = _interopRequireDefault(require("../SurveySelector"));
var _repeatDcws = _interopRequireDefault(require("./repeatDcws.graphql"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var initialValues = {
  toggle: false,
  tabName: 'Final Test',
  navigation: 'noSidebar',
  lockedUntilCompletion: true,
  options: [],
  useRepeatingFinalTest: false,
  parentDeploymentId: null,
  passingThreshold: 80,
  useMaxTries: false,
  maxTries: null,
  maxTriesMessage: '',
  showFinalTestFeedback: true
};
var validate = function validate(values, errors) {
  var localErrors = {};
  if (values.finalTest.toggle) {
    if (!values.finalTest.tabName) {
      localErrors['finalTest.tabName'] = 'Final Test Tab Name is required';
    }
    if (!values.finalTest.useRepeatingFinalTest && values.finalTest.options.length === 0) {
      localErrors['finalTest.options'] = 'You must select at least one Final Test survey';
    }
    if (values.finalTest.useRepeatingFinalTest) {
      if (!values.finalTest.parentDeploymentId) {
        localErrors['finalTest.parentDeploymentId'] = 'You must specify a final test data collection wave';
      }
      var pt = values.finalTest.passingThreshold;
      if (!pt && values.finalTest.passingThreshold !== 0) {
        localErrors['finalTest.passingThreshold'] = 'You must specify a passing threshold';
      } else if (pt < 0 || pt > 100) {
        localErrors['finalTest.passingThreshold'] = 'Passing threshold must be between 0 and 100';
      } else if (parseInt(pt, 10) !== pt) {
        localErrors['finalTest.passingThreshold'] = 'Passing threshold must be an integer';
      }
      if (values.finalTest.useMaxTries === true && values.finalTest.maxTries < 1) {
        localErrors['finalTest.maxTries'] = 'Max tries must be more than 0';
      }
    }
  }
  (0, _assign2["default"])(errors, localErrors);
  return !Object.keys(localErrors).length;
};
var formCoupler = exports.formCoupler = {
  initialValues: initialValues,
  validate: validate,
  errorTab: 'postCourse',
  key: 'finalTest'
};

/* Main Component */
var FormFinalTest = function FormFinalTest(_ref) {
  var assignmentData = _ref.assignmentData,
    toggle = _ref.toggle,
    values = _ref.values,
    formProps = _ref.formProps;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    availableDcws = _useState2[0],
    setAvailableDcws = _useState2[1];
  var questSettings = assignmentData.settings,
    currentSurveylistList = assignmentData.currentSurveylistList;
  (0, _react.useEffect)(function () {
    function loadAvailableDcws() {
      return _loadAvailableDcws.apply(this, arguments);
    }
    function _loadAvailableDcws() {
      _loadAvailableDcws = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var result, dcws, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return _cccisdApollo.client.query({
                query: _repeatDcws["default"],
                fetchPolicy: 'network-only',
                variables: {
                  assignmentId: assignmentData.assignmentId,
                  projectId: assignmentData.groupId
                }
              });
            case 1:
              result = _context.v;
              dcws = (0, _get2["default"])(result, 'data.flows.deploymentList', []) || [];
              setAvailableDcws(dcws.filter(function (dcw) {
                var _dcw$settings;
                return (dcw === null || dcw === void 0 ? void 0 : (_dcw$settings = dcw.settings) === null || _dcw$settings === void 0 ? void 0 : _dcw$settings.isRepeated) === true;
              }));
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error(_t);
              setAvailableDcws([]);
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }));
      return _loadAvailableDcws.apply(this, arguments);
    }
    if (availableDcws === null && toggle) {
      loadAvailableDcws();
    }
  }, [toggle]);
  var renderToggleField = function renderToggleField() {
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "finalTest.toggle",
      component: _cccisdFormik.CccisdToggle,
      label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
        label: "Use Final Test Tab",
        tooltip: "Have the user complete a Final Test."
      })
    });
  };
  var renderConditionalFields = function renderConditionalFields() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "finalTest.tabName",
      component: _cccisdFormik.CccisdInput,
      label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
        label: "Final Test Tab Name",
        tooltip: "The text for Final Test in the tab bar"
      })
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "finalTest.lockedUntilCompletion",
      component: _cccisdFormik.CccisdToggle,
      label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
        label: "Locked Until Course Completion",
        tooltip: "Only allow users to take Final Test after required Course surveys are complete."
      })
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "finalTest.useRepeatingFinalTest",
      component: _cccisdFormik.CccisdToggle,
      label: "Use a repeatable final test"
    }), values.finalTest.useRepeatingFinalTest && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "finalTest.parentDeploymentId",
      component: _cccisdFormik.CccisdSelect,
      label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
        label: "The Final Test Data Collection Wave",
        tooltip: "Must be a repeated Data Collection Wave"
      }),
      options: availableDcws && availableDcws.length ? [{
        label: '-- Select a Data Collection Wave --',
        value: null
      }].concat(_toConsumableArray(availableDcws)) : [{
        label: '-- No Data Collection Waves found --',
        value: null
      }]
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "finalTest.passingThreshold",
      component: _cccisdFormik.CccisdInput,
      label: "The % correct required to pass",
      type: "number"
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "finalTest.useMaxTries",
      component: _cccisdFormik.CccisdToggle,
      label: "Set a maximum amount of test failures before having to revisit the course"
    }), values.finalTest.useMaxTries && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "finalTest.maxTries",
      component: _cccisdFormik.CccisdInput,
      label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
        label: "Maximum test failures",
        tooltip: "After x test failures, user must record some course progress before test is unlocked again. All subsequent failures will require a course revisit."
      }),
      type: "number"
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "finalTest.maxTriesMessage",
      component: _cccisdFormik.CccisdInput,
      label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
        label: "Max test failures exceeded message",
        tooltip: "Recommend leaving this empty. The default message is 'You have not correctly answered {passingPercent}% of the questions after {maxTries} attempts. Please click Continue to revisit the module content. After you review at least one lesson, you can click the Module Final Test tab to retake the test.'"
      })
    })), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "finalTest.showFinalTestFeedback",
      component: _cccisdFormik.CccisdToggle,
      label: "Show Final Test responses"
    })), !values.finalTest.useRepeatingFinalTest && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "finalTest.options",
      label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
        label: "Final Test Surveys",
        tooltip: "Select the survey(s) representing the Final Test."
      }),
      component: _SurveySelector["default"],
      surveyList: currentSurveylistList.surveyList
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert alert-info",
      style: {
        paddingBottom: 0
      }
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "finalTest.navigation",
      label: "Navigation for Final Test",
      component: _ImagePicker["default"],
      options: (0, _navigations.getNavigations)({
        noCourseWrapper: true,
        noCurriculum: true,
        requiredNavigation: (0, _get2["default"])(formProps, 'initialValues.finalTest.navigation')
      }),
      questSettings: questSettings,
      height: "98px",
      settingsFieldName: "finalTest.navigationSettings"
    }))));
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h3", null, "Final Test"), renderToggleField(), toggle && availableDcws !== null && renderConditionalFields());
};
var _default = exports["default"] = FormFinalTest;